import { render, staticRenderFns } from "./IletisimListesi.vue?vue&type=template&id=73141c2f&scoped=true&"
import script from "./IletisimListesi.vue?vue&type=script&lang=js&"
export * from "./IletisimListesi.vue?vue&type=script&lang=js&"
import style0 from "./IletisimListesi.vue?vue&type=style&index=0&id=73141c2f&lang=scss&scoped=true&"
import style1 from "./IletisimListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73141c2f",
  null
  
)

export default component.exports